import React from "react";

import attention from "./assets/Attention.svg";
import close from "./assets/cross.svg";

interface RegisterErrorProps {
    setRegisterError: (show: boolean) => void;
}

const RegisterError: React.FC<RegisterErrorProps> = ({ setRegisterError }) => {
    return (
        <>
            <div className="w-full md:w-[120%] h-full bg-[#1212128d] z-[999] fixed top-0 left-0 md:-left-[20%] p-6 flex justify-center items-center">
                <div className="md:ml-[20%] bg-[#FFFFFF] p-6 rounded-[15px] w-full md:w-[600px]">
                    <div className="w-full h-full bg-[#fff] overflow-y-auto flex flex-col items-center text-center">
                        <span className=" w-full flex items-center justify-between">

                            <img
                                onClick={() => setRegisterError(false)}
                                src={close}
                                className=" w-4 cursor-pointer"
                                alt="Close"
                            />
                        </span>

                        <img src={attention} className=" w-[100px] h-[100px]" alt="Error" />
                        <h2 className=" font-Manrope font-semibold text-xl text-black mt-3">
                            Not Registered for this match
                        </h2>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RegisterError;
